export default {"src":"/_next/static/media/ic-clock.c6ae4289.svg","height":15,"width":15};